import { render, staticRenderFns } from "./PrivacyPolicyScreen.vue?vue&type=template&id=c3540b62&scoped=true&"
import script from "./PrivacyPolicyScreen.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3540b62",
  null
  
)

export default component.exports